export default "__VITE_ASSET__B6m8l17T__"